<template>
    <div v-if="value && Object.keys(value).length > 0">
        <v-toolbar card dark color="primary" class="cabecalho cabecalho-etapas">
            <div class="cabecalho__texto">
                <div class="cabecalho__info">
                    <p>
                        <strong>Nº Processo</strong><br>
                        {{ (value && value.processo) || '--' }}
                    </p>
                  <p v-if="value && value.quantidadeRepeticoes">
                    <strong >Repetição</strong><br>
                    {{ (value && value.quantidadeRepeticoes) || '--' }}
                  </p>
                    <p>
                        <strong>Órgão</strong><br>
                        {{ comprador }}
                    </p>
                    <p>
                        <strong>Objeto</strong><br>
                        {{ objetoTruncado }}
                        <span v-if="objetoCompleto && objetoCompleto.length > 30"
                              @click="mostrarModalObjeto = true"
                              class="cabecalho__link">
                            Ver mais
                        </span>
                    </p>
                    <p v-if="value.tipo === 'COM_DISPUTA'">
                        <strong>Disputa por</strong><br>
                      {{value.disputaPor | cdEnum(disputasCompraDireta)}}
                    </p>
                    <p>
                        <strong>Situação</strong><br>
                        {{ situacaoFormatada }}
                    </p>
                </div>
                <div class="cabecalho__acoes" v-if="value && value.situacao === 'SUSPENSA'">
                    <v-btn
                        outlined
                        small
                        class="cabecalho__motivo-btn"
                        @click="mostrarModalSuspensao = true"
                    >
                        <v-icon left small>mdi-message-text-outline</v-icon>
                        MOTIVO
                    </v-btn>
                </div>
            </div>
        </v-toolbar>

        <!-- Modal para visualizar objeto completo -->
        <v-dialog v-model="mostrarModalObjeto" max-width="600px">
            <v-card>
                <v-card-title class="primary modal-title" primary-title>
                    <span>Objeto da Compra Direta</span>
                    <v-btn flat depressed @click="mostrarModalObjeto = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text class="pa-4">
                    <p>{{ objetoCompleto }}</p>
                </v-card-text>
            </v-card>
        </v-dialog>

        <!-- Modal para visualizar motivo da suspensão -->
        <v-dialog v-model="mostrarModalSuspensao" persistent max-width="800px">
            <modal-suspender-compra-direta
                v-model="value"
                :modo-visualizacao="true"
                :motivo-suspensao="value && value.justificativaSuspensao"
                :anexo-suspensao="value && value.anexoSuspensao"
                @downloadAnexo="tratarEventDownloadAnexoSuspensao"
                @fecharModalSuspensao="mostrarModalSuspensao = false"/>
        </v-dialog>
    </div>
</template>

<script>
import tiposCompraDireta from '@/core/constants/tipos-compra-direta'
import situacoesCompraDireta from '@/core/constants/situacoes-compra-direta'
import ModalSuspenderCompraDireta from '@/views/pages/comprador/execucao-compra-direta/acoes/ModalSuspenderCompraDireta'

export default {
    name: 'MenuProcessoVisualizacao',
    components: {
        ModalSuspenderCompraDireta
    },
    props: {
        value: {
            type: Object,
            required: false,
            default: () => ({})
        }
    },
    data() {
        return {
            mostrarModalObjeto: false,
            mostrarModalSuspensao: false,
        }
    },
    computed: {
        comprador(){
            if(this.value && this.value.comprador && this.value.comprador.sigla){
                return this.value.comprador.sigla
            }
            return '--'
        },
        objetoCompleto(){
            return this.value && this.value.objeto ? this.value.objeto : ''
        },
        objetoTruncado(){
            if(this.objetoCompleto && this.objetoCompleto.length > 30){
                return this.objetoCompleto.substring(0, 30) + '...'
            }
            return this.objetoCompleto || '--'
        },
        disputaPor(){
            if(this.value && this.value.tipoCompraDireta && tiposCompraDireta && tiposCompraDireta.COM_DISPUTA && 
               this.value.tipoCompraDireta === tiposCompraDireta.COM_DISPUTA.valor){
                return tiposCompraDireta.COM_DISPUTA.texto
            }
            if(this.value && this.value.tipoCompraDireta && tiposCompraDireta && tiposCompraDireta.SEM_DISPUTA && 
               this.value.tipoCompraDireta === tiposCompraDireta.SEM_DISPUTA.valor){
                return tiposCompraDireta.SEM_DISPUTA.texto
            }
            return '--'
        },
        situacaoFormatada(){
            if(this.value && this.value.situacao && situacoesCompraDireta){
                return situacoesCompraDireta[this.value.situacao] || this.value.situacao
            }
            return '--'
        }
    },
    methods: {
        tratarEventDownloadAnexoSuspensao(anexoInfo) {
            this.$emit('downloadAnexo', anexoInfo)
        }
    }
}
</script>

<style scoped>
.cabecalho {
    box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.4);
    margin-bottom: 16px;
}

.cabecalho__texto {
    justify-content: space-between;
    width: 100%;
    align-items: center;
    font-size: 12px;
    display: flex;
}

.cabecalho__info {
    display: flex;
    align-items: normal;
}

.cabecalho__texto p {
    margin: 0 20px;
    line-height: 16px;
}

.cabecalho__texto p strong {
    font-size: 14px;
    font-weight: 600;
}

.cabecalho__acoes {
    display: flex;
    align-items: center;
    margin-left: auto;
    padding-right: 20px;
}

.cabecalho__link {
    text-decoration: underline;
    cursor: pointer;
    color: #fff;
}

.cabecalho__motivo-btn {
    background-color: transparent !important;
    border: 1px solid #fff !important;
    color: #fff !important;
    font-size: 12px !important;
    min-width: auto !important;
    padding: 4px 12px !important;
    text-transform: uppercase !important;
    font-weight: 500 !important;
}

.cabecalho__motivo-btn:hover {
    background-color: rgba(255, 255, 255, 0.1) !important;
    border-color: #fff !important;
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.cabecalho__motivo-btn:before {
    background-color: transparent !important;
}

.modal-title {
    justify-content: space-between;
  }

.modal-title .v-btn {
    padding: 0;
    margin: 0;
    color: #fff;
    box-sizing: border-box;
    min-width: 25px;
}

@media (max-width: 768px) {
    .cabecalho__info {
        flex-direction: column;
        align-items: stretch;
    }

    .cabecalho__texto p {
        margin: 10px 20px;
        padding: 10px 0;
        border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    }

    .cabecalho__texto p:last-child {
        border-bottom: none;
    }
}
</style>